import {
  ParameterDropdownStyled,
  StyledHelpText,
} from './ParameterDropdown.styles';
import { DefaultOption } from '../DropdownSelect';
import { OnChangeValue } from 'react-select';
import { FormInput } from '../FormInput';
import { FormInputVariant, FormState } from 'src/types';

interface Props {
  column: number;
  placeholder: string;
  options: DefaultOption[];
  onChange: (value: OnChangeValue<DefaultOption, boolean>) => void;
  key?: string;
  value?: DefaultOption | null;
  manualMenuOpen: boolean;
  state: FormState;
  disabled: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  tabIndex?: number;
  showParameterWarning?: boolean;
  warningText?: string;
  'container-data-testid'?: string;
  'data-testid'?: string;
}

export const ParameterDropdown = ({
  column,
  placeholder,
  options,
  onChange,
  key,
  value,
  manualMenuOpen,
  state,
  disabled,
  tabIndex,
  isMulti,
  isSearchable,
  showParameterWarning,
  warningText = '',
  ...props
}: Props) => (
  <ParameterDropdownStyled
    column={column}
    data-testid={props['container-data-testid']}
  >
    <FormInput
      variant={FormInputVariant.DROPDOWN}
      options={options}
      placeholder={placeholder}
      onChange={onChange}
      key={key}
      value={value}
      menuPlacement="bottom"
      manualMenuOpen={manualMenuOpen}
      state={
        disabled
          ? FormState.DISABLED
          : showParameterWarning
            ? FormState.WARNING
            : FormState.DEFAULT
      }
      disabled={disabled}
      data-testid={props['data-testid']}
      tabIndex={tabIndex}
      isMulti={isMulti}
      isSearchable={isSearchable}
    />
    {showParameterWarning && (
      <StyledHelpText
        state={FormState.WARNING}
        helpText={warningText}
        textSize="medium"
      />
    )}
  </ParameterDropdownStyled>
);
